import { useIntl } from 'react-intl';
import { Form, Row, FormInstance, Col, Typography, Radio } from 'antd';

import {
  CompaniesInfiniteSelectField,
  FloatingFormItem,
} from '@/components/_common';
import { useMatrix } from '@/core/domain/enterprise/Matrix/Matrix.hooks';
import { InvoiceType } from '@/core/domain/invoice/invoices/invoices.enums';
import { DirectSaleModalsFormValues } from '@/core/domain/invoice/invoices/invoices.createTypes';

interface Props {
  form?: FormInstance<DirectSaleModalsFormValues>;
}
const DirectSaleGenerateInvoiceForm = ({ form }: Props) => {
  const intl = useIntl();
  const { Title } = Typography;
  const { data: matrix } = useMatrix();

  return (
    <>
      <Form layout="vertical" form={form}>
        <Row gutter={24}>
          <Col span={24}>
            <FloatingFormItem
              name="companyId"
              label={intl.formatMessage({ id: 'directSale.form.company' })}
            >
              <CompaniesInfiniteSelectField
                disabled={
                  !matrix?.matrixSettings.generateInvoiceDifferentCompanies
                }
              />
            </FloatingFormItem>
          </Col>

          <Col sm={24}>
            <Title level={5}>
              {intl.formatMessage({
                id: 'directSale.generateInvoice.modal.title.modelInvoice',
              })}
            </Title>

            <FloatingFormItem name="invoiceType" initialValue={InvoiceType.NFE}>
              <Radio.Group buttonStyle="solid" optionType="button" size="large">
                <Radio value={InvoiceType.NFE}>
                  {intl.formatMessage({
                    id: 'directSale.generateInvoice.modal.title.modelInvoiceNfe',
                  })}
                </Radio>
                <Radio value={InvoiceType.NFC}>
                  {intl.formatMessage({
                    id: 'directSale.generateInvoice.modal.title.modelInvoiceNfce',
                  })}
                </Radio>
              </Radio.Group>
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default DirectSaleGenerateInvoiceForm;
